import { render, staticRenderFns } from "./NationalitySelectbox.vue?vue&type=template&id=e4d584a0&"
import script from "./NationalitySelectbox.vue?vue&type=script&lang=js&"
export * from "./NationalitySelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports